import * as React from "react";
import { OutlookEmailobj } from "../../Entity/OutlookEmailobj";
import FlagEmailItem from "./FlagEmailItem";
import "./flaggedemail.scss";
export interface IProps {
  data: OutlookEmailobj;
  UpdateMethod;
  Phrases;
  taskfromflagemail;
  usertimezone;
}
export default class FlagItemCalItem extends React.Component<
IProps
> {
  constructor(props) {
    super(props);
  }
  public render() {
   
    return (
      <div
        className="flaggedemail"
        draggable
        onDragStart={e => this.onDragStart(e)}
      >
        <div className={["calitem", "ellips", "draggable"].join(" ")}>
          <FlagEmailItem
            flaggedemail={this.props.data}
            UpdateMethod={this.props.UpdateMethod}
            Phrases={this.props.Phrases}
            taskfromflagemail={this.props.taskfromflagemail}
            usertimezone={this.props.usertimezone}
          />
        </div>
      </div>
    );
  }
  public onDragStart = ev => {
    let dragdata = {
      id: this.props.data.id,
      type: "crmmeeting",
      colno: this.props.data.col,
      property: "duedate",
      source: ev.target.parentElement.id
    };
    ev.dataTransfer.setData("text/plain", JSON.stringify(dragdata));
    /*
        ev.dataTransfer.setData("id", this.props.data.ID.toString());
        ev.dataTransfer.setData("type", 'crmmeeting');
        ev.dataTransfer.setData("colno", this.props.data.MeetingColmn.toString());
        ev.dataTransfer.setData("property", 'MeetRepFollow');
        ev.dataTransfer.setData("source", ev.target.parentElement.id);
        */
    /*ev.dataTransfer.setData("text/plain",this.props.data.ID);
        ev.dataTransfer.setData("text/plain", 'crmmeeting');*/
  };
}
